
import Moderator from '@/models/bread/Moderator/institutionStudent'
export default {
  key:'Student',
  name:{
    singular:'Student',
    plural:'Students',
  },
  parents:[
    'Classroom',
  ],
  grandParents:[
    'Account',
    'Institution'
  ],
  Admin:false,
  Moderator:Moderator,
  Teacher:false,
}